export const defaultUrl = "https://couchbeautyplatform.com"